import { render, staticRenderFns } from "./spiaggia.vue?vue&type=template&id=02fc4d52&"
import script from "./spiaggia.vue?vue&type=script&lang=js&"
export * from "./spiaggia.vue?vue&type=script&lang=js&"
import style0 from "./spiaggia.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports